<div
  class="row align-items-center mt-1"
  style="height: 39px;"
  >
  <div class="col-auto pe-0">
    <div class="btn-group">
      <div
        class="btn btn-sm"
        [class.active]="editor?.blocklyEditor?.searchVisible ?? false"
        (click)="editor?.blocklyEditor?.toggleSearch()"
        aria-expanded="false"
        >
        <i class="ri-search-2-line"></i>

      </div>


    </div>

  </div>
  <div class="col-auto ps-1">
    <div class="btn-group">
      <button
        type="button"
        class="btn btn-sm dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        >
        <span id="blockly-file-select-dropdown">
          {{this.editorItemService.selectedEditorDisplayName}}
        </span>
        <span
          class="text-danger"
          [ngClass]="{'invisible':!this.rss.editorItem?.isDirty}"
        >*</span>
      </button>
      <ul
        class="dropdown-menu"
        style="max-height: 400px; overflow: auto;"
        >
        <ng-container
        *ngTemplateOutlet="fieleSelectButtonLI; context: { item: this.rss.editorItems.global }"></ng-container>
        @if (this.rss.editorItems.stages.length > 0) {
          <li>
            <h6 class="dropdown-header text-primary"><i class="ri-stack-fill"></i> Stages </h6>
          </li>
        }
        @for (item of this.rss.editorItems.stages; track item) {
          <li class="dropdown-item">
            <div class="d-flex justify-content-between align-items-center w-100 ">
              <div class="text-small text-muted fs-6">
                {{ item.stage_name }}
              </div>
              <div class="btn-group ms-2">
                <ng-container *ngTemplateOutlet="fieleSelectButton; context: { item: item.entry }"></ng-container>
                <ng-container *ngTemplateOutlet="fieleSelectButton; context: { item: item.exit }"></ng-container>
              </div>
            </div>
          </li>
        }
        @if (this.rss.editorItems.fusion.length > 0) {
          <li>
            <h6 class="dropdown-header text-primary"><i class="ri-clapperboard-ai-fill"></i> Fusion-Views </h6>
          </li>
        }
        @for (item of this.rss.editorItems.fusion; track item) {
          <ng-container *ngTemplateOutlet="fieleSelectButtonLI; context: { item }"></ng-container>
        }
        @if (this.rss.editorItems.ifthen.length > 0) {
          <li>
            <h6 class="dropdown-header text-primary"><i class="ri-swap-2-fill"></i> Wenn-Dann </h6>
          </li>
        }
        @for (item of this.rss.editorItems.ifthen; track item) {
          <ng-container *ngTemplateOutlet="fieleSelectButtonLI; context: { item }"></ng-container>
        }
      </ul>
    </div>
  </div>

  @if (this.editorItemService.isUniqueIdFromIfThen()) {
    <div
      class="col-auto ps-1"
      >
      <a
        class="btn btn-sm btn-outline-primary"
        [routerLink]="['..', 'if-then']"
        [queryParams]="{ open: this.editorItemService.isUniqueIdFromIfThen()?.id }"
        >
        <i class="ri-swap-2-fill me-1"></i>Zum Wenn-Dann
      </a>
    </div>
  }

  @if (editor?.jsSyntaxError) {
    <div
      class="col d-flex align-items-center justify-content-end"
      >
      <div
        class="alert alert-warning mb-0 py-0 px-2 d-flex align-items-center"
        style="font-size: 12px;"
        >
        <i class="ri-error-warning-line me-1"></i>
        <span><strong>JS-Fehler:</strong> {{editor.jsSyntaxError}}</span>
      </div>
    </div>
  }
  @if (!this.fullscreenLayout.botIsVisible) {
    <div
      class="col-auto ms-auto text-end d-flex align-items-center justify-content-end"
      >
      <div
        class="btn btn-outline-primary btn-sm  border-0"
        (click)="this.fullscreenLayout.toggleBot()"
        >
        🤖
      </div>
      <!-- <app-bot-open-dropdown [smallButton]="true"></app-bot-open-dropdown> -->
    </div>
  }
  <!--
  <div
    class="col text-end"
    *ngIf="!this.fullscreenLayout.botIsVisible"
    >
    <div
      class="btn btn-outline-primary btn-sm  border-0"
      (click)="this.fullscreenLayout.toggleBot()"
      >

      🤖
    </div>
  </div>
  -->
</div>
<div class="row mt-0 flex-grow-1">
  <div
    style="border: 0px solid #ccc;"
    class="mt-1"
    >
    <app-botscript-editor-combined #editor></app-botscript-editor-combined>
  </div>
</div>
<!--- TEMPLATES -->
<ng-template
  #fieleSelectButtonLI
  let-item="item"
  >
  @if (item) {
    <li
      class="dropdown-item cursor-pointer"
      [gotoBlockly]="item"
      [ngClass]="{'active': this.rss.editorItem===item}"
      >
      @if (!this.editorItemService.blocklyIsPossibleFor(item)) {
        <i
          class="ri-code-s-slash-fill text-primary-emphasis"
        ></i>
      } @else {
        <i class="ri-puzzle-2-fill text-primary-emphasis"></i>
      }
      {{item.name}} @if (item.skillid) { ({{item.skillid}}) }
      <span
        class="text-danger"
        [ngClass]="{'invisible':!item.isDirty}"
      >*</span>
    </li>
  }
</ng-template>
<ng-template
  #fieleSelectButton
  let-item="item"
  >
  @if (item) {
    <div
      class="btn btn-sm btn-fileentry d-block text-start text-nowrap"
      [gotoBlockly]="item"
    [ngClass]="{
      'active': this.rss.editorItem===item
      }"
      >
      @if (!this.editorItemService.blocklyIsPossibleFor(item)) {
        <i
          class="ri-code-s-slash-fill text-primary-emphasis"
        ></i>
      } @else {
        <i class="ri-puzzle-2-fill text-primary-emphasis"></i>
      }
      {{item.name}}
      <span
        class="text-danger"
        [ngClass]="{'invisible':!item.isDirty}"
      >*</span>
    </div>
  }
</ng-template>
